import { useAppSelector } from '../../store/store'
import './MenuNetworkDropdown.css'
import { Network, Networks } from '../../constants'
import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'


const MenuNetworkDropdown: React.FC = () => {
  const network = useAppSelector((state) => state.NetworkReducer.network)
  const [searchParams, setSearchParams] = useSearchParams()
  const [isOpen, setIsOpen] = useState(false)

  const toggleHamburgerDropdown = (): void => {
    setIsOpen(!isOpen)
  }

  const handleChangeNetwork = (val: Network) => {
    setIsOpen(false)
    searchParams.set('net', val)
    setSearchParams(searchParams, { replace: false }) // Push a new history entry
  }

  const DropdownIcon = isOpen ? ChevronUpIcon : ChevronDownIcon

  return (
    <div className="hamburger-menu-network-select nav-bar-link-wrapper">
      <div className="hamburger-menu-network-header" onClick={toggleHamburgerDropdown}>
        <div className="hamburger-menu-network-header-title nav-link-name">
          Network
        </div>
        <DropdownIcon className="hamburger-menu-network-header-icon" />
      </div>
      {
        isOpen && (
          <div className={'hamburger-menu-network-items'}>
            {
              Networks.map((n) => (
                <div key={n}
                     className={`nav-link-name hamburger-menu-network-item ${n === network ? 'selected' : ''}`}
                     onClick={() => {
                       handleChangeNetwork(n)
                     }}
                >
                  {n.toLowerCase()}
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  )
}

export default MenuNetworkDropdown
